import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/lib/legal-content";

export const Route = createFileRoute("/dmca")({
  component: DMCAPage,
  head: () => ({
    meta: [
      { title: "DMCA & Copyright Policy — CoderLity" },
      { name: "description", content: "DMCA takedown policy and how to submit copyright infringement notices to CoderLity." },
      { property: "og:url", content: "/dmca" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/dmca" }],
  }),
});

function DMCAPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="DMCA & Copyright Policy"
      sub="How to report copyright infringement."
      updated="May 1, 2026"
      sections={[
        { heading: "Filing a notice", body: "Send takedown notices to dmca@coderlity.com. Include: identification of the work, the infringing URL, your contact details, a good-faith statement, an accuracy statement, and your signature." },
        { heading: "Counter-notice", body: "If your content was removed in error, submit a counter-notice with the same details plus a statement under penalty of perjury." },
        { heading: "Repeat infringers", body: "Accounts that receive multiple valid notices will be suspended or terminated in accordance with our Terms of Service." },
        { heading: "False claims", body: "Knowingly filing a false notice may result in liability for damages under 17 U.S.C. § 512(f)." },
      ]}
    />
  );
}
